module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/produto/produto.component.css
// module id = ./src/app/produto/produto.component.css
// module chunks = main